import request from '@/utils/analyticsRequest'

export function getContentSettings() {
  return request({ url: '/api/v1/ghl/content/settings', method: 'get' })
}

export function updateContentSettings(data) {
  return request({ url: '/api/v1/ghl/content/settings', method: 'put', data })
}

export function syncSocialAccounts() {
  return request({ url: '/api/v1/ghl/content/social-accounts', method: 'get' })
}

export function getSocialAccountStatistics(params = {}) {
  return request({
    url: '/api/v1/ghl/content/social-accounts/statistics',
    method: 'get',
    params
  })
}

export function getSocialAccountStatisticsHistory(params = { days: 30 }) {
  return request({
    url: '/api/v1/ghl/content/social-accounts/statistics/history',
    method: 'get',
    params
  })
}

export function startSocialConnect(platform, data = {}) {
  return request({
    url: `/api/v1/ghl/content/social-accounts/connect/${platform}/start-session`,
    method: 'post',
    data
  })
}

export function getSocialConnectRedirect(platform, token) {
  return request({
    url: `/api/v1/ghl/content/social-accounts/connect/${platform}/start`,
    method: 'get',
    params: { token }
  })
}

export function getSocialConnectCandidates(platform, accountId) {
  return request({
    url: `/api/v1/ghl/content/social-accounts/connect/${platform}/candidates`,
    method: 'get',
    params: { accountId }
  })
}

export function completeSocialConnect(platform, data) {
  return request({
    url: `/api/v1/ghl/content/social-accounts/connect/${platform}/complete`,
    method: 'post',
    data
  })
}

export function disconnectSocialAccount(platform, accountId) {
  return request({
    url: `/api/v1/ghl/content/social-accounts/${platform}`,
    method: 'delete',
    params: { accountId }
  })
}

export function updateSocialAccount(platform, accountId, { fanoutEnabled, agentId, clearAgentId } = {}) {
  const payload = {
    fanoutEnabled,
    clearAgentId
  };

  if (agentId === null || agentId === '') {
    payload.clearAgentId = true;
    payload.agentId = null;
  } else if (agentId !== undefined) {
    payload.agentId = agentId;
  }

  return request({
    url: `/api/v1/ghl/content/social-accounts/${platform}`,
    method: 'patch',
    params: { accountId },
    data: payload,
    headers: { 'Content-Type': 'application/json' }
  })
}

export function updateSocialAccountFanout(platform, accountId, fanoutEnabled) {
  return updateSocialAccount(platform, accountId, { fanoutEnabled })
}

function campaignRequest({ method, url, payload, files = [] }) {
  const formData = new FormData()
  formData.append('payload', JSON.stringify(payload))
  for (const file of files) {
    formData.append('files', file)
  }
  return request({
    url,
    method,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000
  })
}

export function createContentCampaign(payload, files = []) {
  return campaignRequest({
    method: 'post',
    url: '/api/v1/ghl/content/campaigns',
    payload,
    files
  })
}

export function updateContentCampaign(id, payload, files = []) {
  return campaignRequest({
    method: 'put',
    url: `/api/v1/ghl/content/campaigns/${id}`,
    payload,
    files
  })
}

export function publishContentCampaign(id) {
  return request({
    url: `/api/v1/ghl/content/campaigns/${id}/publish`,
    method: 'post',
    timeout: 120000
  })
}

export function listContentCampaigns(params) {
  return request({ url: '/api/v1/ghl/content/campaigns', method: 'get', params })
}

export function getContentCampaign(id) {
  return request({ url: `/api/v1/ghl/content/campaigns/${id}`, method: 'get' })
}

export function getContentCampaignFanout(id, params) {
  return request({ url: `/api/v1/ghl/content/campaigns/${id}/fanout`, method: 'get', params })
}

export function retryContentCampaign(id) {
  return request({ url: `/api/v1/ghl/content/campaigns/${id}/retry`, method: 'post', timeout: 120000 })
}

export function listContentMedia(params) {
  return request({ url: '/api/v1/ghl/content/media', method: 'get', params })
}

export function deleteContentMedia(id) {
  return request({ url: `/api/v1/ghl/content/media/${id}`, method: 'delete' })
}

export function uploadChatMedia(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/api/v1/ghl/content/media/upload',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000
  })
}

export function getContentMediaStatus(id) {
  return request({ url: `/api/v1/ghl/content/media/${id}`, method: 'get' })
}
